import { defineComponent as _defineComponent } from 'vue'
import { ModalHelper } from '@/helpers/modal-helper';
import { ref } from 'vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { useUserStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMenuButton',
  setup(__props) {

const { isLoggedIn, loginProgress } = useUserStore();
const loading = ref<boolean>(false);

async function handleLoginClick() {
	loading.value = true;

	if (isLoggedIn.value) {
		await ModalHelper.openModal(SettingsModal, { closable: true });
	} else {
		await ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'LoginMenuButton');
	}

	loading.value = false;
}

return { __sfc: true,isLoggedIn, loginProgress, loading, handleLoginClick }
}

})